module.exports = __webpack_public_path__ + "img/logo-white.6a116963.png";